/**
 * Invoice Type
 *
 * Domain-specific invoice document types used internally in the application.
 * This is a simplified classification that abstracts away format-specific details.
 *
 * These types can be mapped to various export formats (ISDOC, UBL, Peppol, etc.)
 * using the mapping functions provided in this library.
 */
export const InvoiceType = {
  INVOICE: 'INVOICE', // Standard invoice - Běžná faktura
  CREDIT_NOTE: 'CREDIT_NOTE', // Credit note - Dobropis
  DEBIT_NOTE: 'DEBIT_NOTE', // Debit note - Vrubopis
  PROFORMA: 'PROFORMA', // Proforma invoice (non-tax advance) - Zálohová faktura (proforma)
  ADVANCE: 'ADVANCE', // Advance payment invoice (tax document) - Zálohová faktura (daňový doklad)
  RECEIPT: 'RECEIPT', // receipt / simplified tax document - Účtenka / zjednodušený daňový doklad
  OTHER: 'OTHER' // Other document type - Jiný typ dokladu
} as const;

export type InvoiceType = (typeof InvoiceType)[keyof typeof InvoiceType];
